const newQuoteItems = document.querySelectorAll('.new-form-item')

if (newQuoteItems.length > 0) {
    newQuoteItems.forEach(function(item) {
        item.addEventListener('input', function() {
            item.classList.remove('new-quote-form-error')
            if (item.parentNode.children[2].classList.contains('new-quote-form-block-wrapper-item-description', 'new-quote-form-danger')) {
                item.parentNode.children[2].classList.add('new-quote-form-d-none')
            }
        })
        if (item.children[0]) {
            item.parentNode.addEventListener('click', function() {
                if (item.children[0].classList.contains('changed')) {
                    item.classList.remove('new-quote-form-error')
                    if (item.parentNode.children[2].classList.contains('new-quote-form-block-wrapper-item-description', 'new-quote-form-danger')) {
                        item.parentNode.children[2].classList.add('new-quote-form-d-none')
                    }
                }
            })
        }
    })
}